export const TITLE = "Agregar usuario";
export const SUB_TITLE = "Ingrese los datos del nuevo usuario";
